import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined, BarChartOutlined, DatabaseOutlined, CloudServerOutlined, CloudOutlined, LinkOutlined } from '@ant-design/icons';
import logoNormal from '../assets/images/DataViz Final Logo.svg';
import '../css/Sidebar.css';

const { Sider } = Layout;

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  // Notify parent of collapse state change
  const handleCollapse = (collapsedState: boolean) => {
    setCollapsed(collapsedState);
  };

  // Get the selected key from the URL path
  const selectedKey = location.pathname.split('/').filter(Boolean)[0] || 'dashboard';

  // Menu sections
  const menuSections = [
    {
      key: 'dashboard',
      icon: <HomeOutlined />,
      label: 'Dashboard',
      path: '/dashboard',
    },
    {
      key: 'uc1',
      icon: <BarChartOutlined />,
      label: 'Use Case 1',
      path: '/uc1',
    },
    // {
    //   key: 'uc2',
    //   icon: <DatabaseOutlined />,
    //   label: 'Use Case 2',
    //   path: '/uc2',
    // },
    {
      key: 'uc3',
      icon: <BarChartOutlined />,
      label: 'Use Case 3',
      path: '/uc3',
    },
    // {
    //   key: 'rdfox-explorer',
    //   icon: <CloudServerOutlined />,
    //   label: 'RDFox Explorer',
    //   path: '/rdfox-explorer',
    // },
    {
      key: 'simple-s3-explorer',
      icon: <CloudOutlined />,
      label: 'S3 Explorer',
      path: '/simple-s3-explorer',
    },
    // {
    //   key: 'integrated-explorer',
    //   icon: <LinkOutlined />,
    //   label: 'RDFox + S3',
    //   path: '/integrated-explorer',
    // },
  ];

  // Convert the menuSections array to the items array required by Ant Design
  const menuItems = menuSections.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: <Link to={item.path}>{item.label}</Link>,
  }));
  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={handleCollapse}
      width={260}
      collapsedWidth={80}
      theme='light'
    >
      {/* Logo */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: collapsed ? '10px' : '16px',
        overflow: 'hidden',
        cursor: 'pointer',
      }}>
        <img
          src={logoNormal}
          alt='DataBri-X Logo'
          style={{
            height: 'auto',
            width: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        />
      </div>

      {/* Render Menu */}
      <Menu
        theme='light'
        mode='inline'
        selectedKeys={[selectedKey]}
        items={menuItems}
        className='sider-menu'
      />

    </Sider>
  );
};

export default Sidebar;